var _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";
import { forwardRef } from "react";

var SvgIconnotificationhandoff = function SvgIconnotificationhandoff(_ref, ref) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "59px",
    height: "62px",
    viewBox: "0 0 59 62",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    role: "img",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "Icons/Notifications/icon.notification.handoff") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Icons/Notifications/icon.notification.handoff",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group",
    transform: "translate(1.556275, 37.350607)",
    fill: "#FFFFFF",
    stroke: "#303030",
    strokeWidth: 2
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle",
    x: 1,
    y: 1,
    width: 9.26577069,
    height: 18.7366309
  }), /*#__PURE__*/React.createElement("path", {
    d: "M10.195119,2.41768736 C18.8661081,2.82015709 23.9170632,3.39959419 25.347984,4.15599865 C30.2085549,6.72536329 29.1884012,7.54057928 29.6968065,7.54057928 C30.2052118,7.54057928 35.8588643,7.20659808 38.0544577,7.54059987 C40.4738501,7.90864679 41.0792981,9.38961484 41.0792981,10.9353594 C41.0792981,12.4811041 39.3367739,13.7426547 38.0544577,13.7426547 C33.182115,13.7426547 26.633132,13.2891652 26.633132,13.7426547 C26.633132,14.1961443 38.0544577,13.7426547 38.0544577,13.7426547 C38.5111078,13.7426547 39.5320515,13.5022667 40.2126138,12.8809085 C40.7887456,12.354896 41.0595857,11.4457707 41.1721116,11.3167386 C41.4566979,10.9904072 50.8321917,9.08328599 51.8998687,8.63584554 C53.577819,7.93265271 55.2007757,7.96364839 55.7959024,9.41561672 C56.3910292,10.867585 55.7865301,11.8689858 54.4982627,12.706752 C52.8377399,13.7865976 35.8093248,23.3441296 32.5186472,23.3441296 C30.3248622,23.3441296 22.8836861,21.2495353 10.195119,17.0603468 L10.195119,2.41768736 Z",
    id: "Path-8"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group-2",
    transform: "translate(10.893927, 1.556275)",
    stroke: "#303030",
    strokeWidth: 2
  }, /*#__PURE__*/React.createElement("path", {
    d: "M18.5634254,0 C26.358352,0 28.9005895,7.0688579 28.9005895,8.31155548 C28.9005895,9.55425306 29.8018783,17.5537728 30.8574182,19.2110859 C31.912958,20.8683989 33.8184156,23.0271195 35.3355981,24.166664 C36.8527807,25.3062086 38.0720603,29.3961734 36.8527807,29.3961734 C35.6335011,29.3961734 1.67132899,29.3961734 0.573140457,29.3961734 C-0.525048081,29.3961734 0.0176798576,25.4721483 1.66579545,24.166664 C3.31391104,22.8611798 5.19711514,21.0782083 6.37106186,19.2110859 C7.54500858,17.3439635 8.67178252,10.058145 8.67178252,8.31155548 C8.67178252,6.564966 10.7684989,0 18.5634254,0 Z",
    id: "Path-9",
    fill: "#FFFFFF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M10.6903749,29.3961734 C12.0654026,33.6616125 14.7270455,35.794332 18.6753036,35.794332 C22.6235618,35.794332 25.1643357,33.6616125 26.2976253,29.3961734 C26.2976253,29.3961734 10.6903749,29.3961734 10.6903749,29.3961734 Z",
    id: "Path-10",
    fill: "#FFFFFF"
  }), /*#__PURE__*/React.createElement("line", {
    x1: 4.12407991,
    y1: 22.1173873,
    x2: 26.2976253,
    y2: 22.1173873,
    id: "Path-11",
    strokeLinecap: "round"
  })))));
};

var ForwardRef = /*#__PURE__*/forwardRef(SvgIconnotificationhandoff);
export { ForwardRef as ReactComponent };
export default __webpack_public_path__ + "static/media/icon.notification.handoff.a2d0744f9b988276a502b0828a000add.svg";